<template>
    <ui-modal>
        <template #header>
            <h3 class="mb-1 text-center" v-text="'Płatność nie powiodła się!'" />
        </template>

        <div class="text-center mb-3">
            <a-icon icon="ErrorCircle" width="40px" height="40px" />
        </div>
        <p class="text-primary text-center font-weight-semi">
            Napotkaliśmy problem z pobraniem należności.
            Nic się nie stało! Możesz spróbować ponownie. <br />
            Jeśli problem będzie się powtarzać, napisz na
            <a href="mailto:pomoc@kaucyjni.pl">pomoc@kaucyjni.pl</a>.
            Postaramy się pomóc!
        </p>

        <template #footer>
            <the-btn
                text="Zamknij"
                class="btn-outline-custom"
                @click="$emit('close-modal')"
            />
            <the-btn
                text="Spróbuj ponownie"
                class="btn-secondary"
                @click="goToConfigurationSummary"
            />
        </template>
    </ui-modal>
</template>

<script>
export default {
    methods: {
        async goToConfigurationSummary() {
            await this.$store.dispatch('drsTariffs/loadTariffConfigFromStorage')

            this.$store.dispatch('openModal', {
                componentPath: 'drs/configuration/ConfigurationSummary'
            })
        }
    }
}
</script>